import { TThunkAction } from '../../types/redux';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { unselectAll } from '../../actions/selected';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import {
  fetchRemoveOffersFromFolder,
  IRemoveOffersFromFolderRequest,
} from '../../repositories/favorites/v1/remove-offers-from-folder';
import { refreshFolders } from '.';

export const removeOffersFromFolder = (offerIds: number[], folderId: number): TThunkAction<Promise<void>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const parameters: IRemoveOffersFromFolderRequest = {
    folderId,
    offerIds,
  };

  const showError = () => dispatch(notify('Не удалось удалить объекты из подборки', ENotificationStyle.Error));

  try {
    const { statusCode, response } = await fetchRemoveOffersFromFolder({ httpApi, parameters });

    if (statusCode === 200) {
      dispatch(unselectAll());
      dispatch(fetchFavoriteEntities({ offset: 0 }));
      dispatch(refreshFolders());
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to remove offers from folder',
    });
  }
};
